module.exports = __webpack_public_path__ + "img/university_17.5987779a.png";